import React, { useRef } from "react";
import styles from "./tag-display.module.css";
import { ITaskController } from "../../controller";
import { Tag } from "shared/datamodel/schemas/metadata";
import { Tooltip } from "frontend/ui-components/design-system/tooltip/tooltip";
import { useTextTruncation } from "frontend/hooks/use-text-truncation";
import { useTaskTags } from "../hooks/use-task-tags";

interface TagDisplayProps {
  controller: ITaskController;
}

export function TagDisplay({ controller }: TagDisplayProps) {
  const selectedTags = useTaskTags(controller);

  if (selectedTags.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      {selectedTags.map((tag, index) => (
        <TagItem key={index} tag={tag} />
      ))}
    </div>
  );
}

function TagItem({ tag }: { tag: Tag }) {
  const textRef = useRef<HTMLSpanElement>(null);
  const isTextTruncated = useTextTruncation(textRef, [tag.name]);

  return (
    <Tooltip text={tag.name} disabled={!isTextTruncated} offset={8} maxWidth={450}>
      <div className={styles.tag} style={{ backgroundColor: tag.color }}>
        <span ref={textRef} className={styles.tagText}>
          {tag.name}
        </span>
      </div>
    </Tooltip>
  );
}
